import React from 'react';
import Icon from '../Icons';

import * as S from './styles';

function Alert({ type = 2, title, message, style }) {
    const fromTo = {
        1: 'error',
        2: 'warning',
        3: 'success',
        4: 'info',
    };

    return (
        (!!title || !!message) && (
            <S.AlertContainer style={style} className={`alert ${fromTo[type]}`}>
                <S.AlignMessage>
                    <div className="icon-container">
                        <S.AlignIcon>
                            {fromTo[type] === 'error' && <Icon name="ErrorIcon" color="#EC130F" size={32} />}
                            {fromTo[type] === 'warning' && <Icon name="StatusTriangleIcon" color="#F49E00" size={32} />}
                            {fromTo[type] === 'success' && <Icon name="CheckCircleIcon" color="#0B8A1C" size={32} />}
                            {fromTo[type] === 'info' && <Icon name="StatusCircleIcon" color="#0B7EB5" size={32} />}
                        </S.AlignIcon>
                    </div>

                    <div className="text-container">
                        {title && <h3>{title}</h3>}
                        {message && <span>{message}</span>}
                    </div>
                </S.AlignMessage>
            </S.AlertContainer>
        )
    );
}

export default Alert;
